import styled from "styled-components";

export const ScreenReader = styled.span`
  position: absolute;
  display: block;
  cursor: text;
  margin: -1px 0 0 -1px;
  padding: 0;
  width: 1px;
  height: 1px;
  font-weight: normal;
  font-size: 15px;
  line-height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  outline: 0;
`;
